module.exports = __webpack_public_path__ + "img/emv_nl-BE.37ace50a.svg";